module.exports = __webpack_public_path__ + "img/logo_标e选.bac49b79.png";